import type { SVGProps } from 'react';

const SvgSmartphone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 3H8C6.35 3 5 4.35 5 6v12c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3m1 15c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h1v1s0 1 1 1h4s1 0 1-1V5h1c.55 0 1 .45 1 1z"
    />
    <path fill="currentcolor" d="M12 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
  </svg>
);
export default SvgSmartphone;
